<div class="root">
  <!-- eslint-disable sky/restrict-ng-model -->
  <quill-editor
    class="editor"
    [class.-disabled]="disabled"
    format="html"
    [ngModel]="content"
    [modules]="modules"
    [bounds]="'self'"
    [sanitize]="true"
    [preserveWhitespace]="false"
    [placeholder]="placeholder"
    [scrollingContainer]="scrollingContainer"
    [disabled]="disabled"
    (onContentChanged)="handleContentChanged($event)"
    (onEditorCreated)="init($event)"
  ></quill-editor>
  <!-- eslint-enable sky/restrict-ng-model -->
  @if (isImageLoading$ | async) {
    <div class="overlay">
      <ds-spinner size="m"></ds-spinner>
    </div>
  }
</div>
